// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductDisplayFrequentlyOrdered_container__ho4wx"};